import {VyrocniZprava} from "../../src/interfaces/interfaces";

const vyrocniZpravySpolku : VyrocniZprava[] = [
    {
        year: 2015,
        pdf: 'vyrocni_zp_2015.pdf'
    },
    {
        year: 2016,
        pdf: 'vyrocni_zp_2016.pdf'
    },
    {
        year: 2017,
        pdf: 'vyrocni_zp_2017.pdf'
    },
    {
        year: 2018,
        pdf: 'vyrocni_zp_2018.pdf'
    },
    {
        year: 2019,
        pdf: 'vyrocni_zp_2019.pdf'
    },
    {
        year: 2020,
        pdf: 'vyrocni_zp_2020.pdf'
    },
    {
        year: 2021,
        pdf: 'vyrocni_zp_2021.pdf'
    },
    {
         year: 2022,
         pdf: 'Výroční zpráva za rok 2022.pdf'
    },
    {
         year: 2023,
         pdf: 'Výroční zpráva SK TRASKO Vyškov za rok 2023.pdf'
    },
    {
         year: 2024,
         pdf: 'Výroční zpráva za rok 2024.pdf'
    },
    
]

export default vyrocniZpravySpolku
